// @flow
import { createSelector } from "reselect"
import { merge } from "ramda"
import theme from "@kiwicom/orbit-components/lib/defaultTheme"
import { getBreakpointWidth } from "@kiwicom/orbit-components/lib/utils/mediaQuery"
import { QUERIES } from "@kiwicom/orbit-components/lib/utils/mediaQuery/consts"

import { TYPES } from "common/consts/windowConsts"
import type { WindowType } from "common/consts/windowConsts"
import type { WindowResizeAction } from "./actions"

export default function WindowReducer(
  state: * = { type: TYPES.DESKTOP },
  action: WindowResizeAction,
) {
  switch (action.type) {
    case "WINDOW_RESIZE":
      return merge(state, { type: action.windowType, width: action.width })

    default:
      return state
  }
}

export const windowSelector = (state: { window: * }) => state.window

export const windowTypeSelector: (state: {
  window: *,
}) => WindowType = createSelector(
  windowSelector,
  state => state.type,
)

export const isMobileSelector: (state: { window: * }) => boolean = createSelector(
  windowTypeSelector,
  type => type === TYPES.MOBILE,
)

export const isSmallerThanDesktopSelector: (state: { window: * }) => boolean = createSelector(
  windowTypeSelector,
  type => type === TYPES.MOBILE || type === TYPES.TABLET,
)

export const isOrbitTabletSelector: (state: {
  window: *,
}) => boolean = createSelector(
  windowSelector,
  state => state.width < getBreakpointWidth(QUERIES.TABLET, theme, true),
)
